import { createSelector } from "reselect";
import { AppState } from "../appState";

// Base selector to access terminal master state
export const terminalSelector = (state: AppState) => state.terminalMaster;

// Memoized selector to get terminal values master
export const terminalValuesSelector = createSelector(
  [terminalSelector],
  (terminals) =>
    terminals
      .filter(({ region }) => region !== null)
      .map(({ terminalId }) => terminalId)
      .sort((a, b) => a?.localeCompare(b))
);

// Memoized selector to get terminal values with name master

export const terminalWithNameSelector = createSelector(
  [terminalSelector],
  (terminals) =>
    terminals
      .filter(({ region }) => region !== null)
      .sort((a, b) => a?.terminalId?.localeCompare(b?.terminalId))
      .map(
        ({
          terminalId,
          terminalName,
          fax,
          localTelephone,
          terminalAddress1,
          terminalAddress2,
          terminalCity,
          terminalState,
          terminalZip,
        }) => ({
          terminalId,
          terminalName,
          fax,
          localTelephone,
          terminalAddress1,
          terminalAddress2,
          terminalCity,
          terminalState,
          terminalZip,
        })
      )
);
